import { formatBytes } from "./catalogMappingTableUtils";
import { sanitizeSingleLine } from "./importMessagesDisplay";
import { RAW_FEED_EMPTY_MESSAGE } from "./tabStatusMessages";

export const resolveRawFeedTabStatus = (rawFeed, loading, { fetched = false } = {}) => {
  if (!fetched || loading) {
    return null;
  }

  if (rawFeed?.exists && rawFeed?.path) {
    const parts = [`${rawFeed.path} — ${formatBytes(rawFeed.size_bytes)}`];
    if (rawFeed.updated_at) {
      parts.push(`agg. ${new Date(rawFeed.updated_at).toLocaleString("it-IT")}`);
    }
    if (rawFeed.message?.trim()) {
      parts.push(sanitizeSingleLine(rawFeed.message));
    }
    return {
      severity: rawFeed.message?.trim() ? "info" : "success",
      text: sanitizeSingleLine(parts.join(" — ")),
    };
  }

  if (rawFeed?.message?.trim()) {
    return {
      severity: rawFeed.exists ? "info" : "warning",
      text: sanitizeSingleLine(rawFeed.message),
    };
  }

  return {
    severity: "warning",
    text: RAW_FEED_EMPTY_MESSAGE,
  };
};
